var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row g-2 mb-2"},_vm._l((_vm.displayCards),function(card){return _c('div',{key:card.label,staticClass:"col-md-3 col-6"},[_c('div',{staticClass:"stat-glass-card"},[_c('div',{staticClass:"stat-label"},[_vm._v(_vm._s(card.label))]),_c('div',{staticClass:"stat-value"},[_vm._v(_vm._s(card.display))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }